<template>
  <footer class="the-footer mt-200 mb-400">
    <section class="banner content-wrap px-100 mb-300">
      <div class="flex flex-wrap gap-200 mb-200">
        <TheFooterRegisteredCourier v-if="variant === 'full'" class="banner-child py-300 px-400" />

        <LcCard radius="large" shadow="none" class="w-full payment-icons">
          <PaymentMethodSymbols key="payment-icons" gap="lg" outlined />
        </LcCard>

        <TheFooterLinkCollection
          v-if="!isNativeApp"
          class="banner-child py-300 px-400"
          gap="md"
          type="app"
        />
      </div>
      <div class="flex flex-wrap gap-200">
        <TheFooterLinkCollection
          class="banner-child py-300 px-400"
          full-width
          gap="2xl"
          type="social"
        />
        <article class="banner-child py-100 px-200">
          <LanguageSwitch variant="discreet" />
        </article>
      </div>
    </section>

    <section class="foot-note">
      <div class="content-wrap flex flex-col gap-300 px-200">
        <TheFooterNavigation />

        <article v-if="content" class="address caption-regular flex flex-wrap">
          <strong v-if="content.copyright">
            {{ content.copyright }}
          </strong>
          <p v-if="content.address">
            {{ content.address }}
          </p>
        </article>

        <TheFooterResponsiblePlay />
      </div>
    </section>
  </footer>
</template>

<script lang="ts" setup>
import type { TheFooterProps } from '~/components/TheFooter/TheFooter.vue'

const { variant = 'condensed' } = defineProps<TheFooterProps>()

const { data: footer } = useContent().getFooter()
const { isNativeApp } = useCustomContext()

const content = computed(() => {
  if (!footer.value?.items?.[0]) return null
  const { addressLine, copyrightLine } = footer.value.items[0]

  return {
    address: addressLine ?? null,
    copyright: copyrightLine ?? null,
  }
})
</script>

<style lang="scss" scoped>
.the-footer {
  .payment-icons {
    padding: token('size/space/gap/100') token('size/space/gap/200');
  }

  .address {
    column-gap: token('size/space/gap/200');
  }

  .banner {
    &-child {
      flex-grow: 1;
      width: 368px;
      border-radius: token('size/radius/l');
      background-color: token('color/background/primary/primary');
    }
  }

  .foot-note {
    color: token('color/text/primary/primary');
  }
}
</style>
